import styles from "@/styles/Footer.module.css";
import Link from "next/link";
import {Facebook, Instagram, MapPin, Mail} from "lucide-react";

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.socials}>
        <Link href="https://facebook.com/profile.php?id=100063759514675" aria-label="Bumpfun's Facebook." target="_blank">
          <Facebook size={35} />
        </Link>
        <Link href="https://instagram.com/bumpfun" aria-label="Bumpfun's Instagram." target="_blank">
          <Instagram size={35} />
        </Link>
      </div>
      <div className={styles.contactBox}>
        <div className={styles.contact}>
          <Link
            className={styles.location}
            href="https://www.google.com/maps/search/?api=1&query=%22BumpFun%20VOF%2C%20L%20Devillersstraat%2049%2C%201654%20Huizingen%2C%20Belgium%22"
            aria-label="Bumpfun's location."
            target="_blank"
          >
            <div className={styles.mapPin}>
              <MapPin className={styles.mapPinIcon} />
            </div>
            <div className={styles.address}>
              <p>FMO BV</p>
              <p>L. Devillersstraat 49</p>
              <p>1654 Huizingen</p>
              <p>Belgium</p>
            </div>
          </Link>
          <Link className={styles.mailText} href="mailto:info@bumpfun.be">
            <div className={styles.mail}>
              <Mail className={styles.mailIcon} />
            </div>
            <p>info@bumpfun.be</p>
          </Link>
          <p className={styles.btw}>BTW: BE 0630.909.774</p>
        </div>
      </div>
    </footer>
  );
}
